import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AttendeeComponent } from './attendee/attendee.component';
import { AttendeesComponent } from './attendees/attendees.component';
import { GeneralConfigComponent } from './general-config/general-config.component';
import { RoomsComponent } from './rooms/rooms.component';
import { TimeslotsComponent } from './timeslots/timeslots.component';
import { TimetableEntriesComponent } from './timetable-entries/timetable-entries.component';
import { TimetableEntryComponent } from './timetable-entry/timetable-entry.component';
import {TagsComponent} from './tags/tags.component';

const adminRoutes: Routes = [
  { path: '', redirectTo: 'generalConfig', pathMatch: 'full' },
  { path: 'generalConfig', component: GeneralConfigComponent },
  { path: 'timeslots', component: TimeslotsComponent },
  { path: 'rooms', component: RoomsComponent },
  { path: 'tags', component: TagsComponent },
  { path: 'timetableEntries', component: TimetableEntriesComponent },
  { path: 'timetableEntries/:id', component: TimetableEntryComponent },
  { path: 'timetableEntries/:tteId/attendees', component: AttendeesComponent },
  { path: 'timetableEntries/:tteId/attendees/:attendeeId', component: AttendeeComponent },
  { path: 'attendees', component: AttendeesComponent },
  { path: 'attendees/:attendeeId', component: AttendeeComponent }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(adminRoutes, { useHash: true })
  ]
})
export class AppRoutingModule { }
